import { render, staticRenderFns } from "./PaymentRemittanceList.vue?vue&type=template&id=1237a4f0&scoped=true&"
import script from "./PaymentRemittanceList.vue?vue&type=script&lang=js&"
export * from "./PaymentRemittanceList.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRemittanceList.vue?vue&type=style&index=0&id=1237a4f0&lang=scss&scoped=true&"
import style1 from "./PaymentRemittanceList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1237a4f0",
  null
  
)

export default component.exports